import React from 'react';

import t from '../../../i18n/t';
import CheckBox from '@components/common/CheckBox';
import TippyTooltip from '@components/common/tooltip/TippyTooltip';
import { PopupCheckLabel, PopupCheckRow } from './EstimatePopup';

type Props = {
  // The category's other tasks with no time yet.
  others: number;
  categoryName: string;
  checked: boolean;
  onToggle: () => void;
};

/**
 * "Also for 12 other Homework" under a first estimate's question (Petr, 2026-10-29), in the sidebar card's Estimate
 * popup and Auto-plan's Not estimated list: ticked, the pick goes to the category's tasks with no time and becomes its
 * default. Hovering it says so.
 */
const FirstEstimateBox = ({ others, categoryName, checked, onToggle }: Props) => (
  <TippyTooltip
    target={
      <PopupCheckRow>
        <CheckBox checked={checked} onChange={onToggle} />
        <PopupCheckLabel onClick={onToggle}>{t.FIRST_ESTIMATE_ALSO(others, categoryName)}</PopupCheckLabel>
      </PopupCheckRow>
    }
    content={t.FIRST_ESTIMATE_ALSO_HINT(categoryName)}
    width={'240px'}
  />
);

export default FirstEstimateBox;
